import React from 'react';
import { Link } from 'react-router-dom';
import useHomePanels from '../custom-hooks/useHomePanels';

function HomePanels (props) {
  const [homePanels, isLoading] = useHomePanels();
  if (isLoading === true) {
    return <p>Loading...</p>;
  }

  if (homePanels.length === 2) {
    return (
        <div className="panelHolder" id="homePanelHolder">
            <div className="row">
            {homePanels.map(hPanel => {
                const ctaURL = "../" + hPanel.fields.link;
                const svgString = hPanel.fields.svgCode;
      return (
            <div className="col-sm-6 col-lg-6 homePanel" key={hPanel.fields.title}>
                <div className="panelSvg">
                    <Link to={ctaURL} reloadDocument className="ctaLink" >
                    <div className="panelIcon panelIconHover" 
                        dangerouslySetInnerHTML={{
                        __html: svgString,
                    }}
                    />
                    </Link>
                </div>
                <h2 className="panelTitle">{hPanel.fields.title}</h2>
                <p className="panelText">{hPanel.fields.description}</p>
                <Link to={ctaURL} reloadDocument className="ctaLink" key={hPanel.fields.link}>FIND OUT MORE...</Link>
            </div>
      );
    })}
            </div>
        </div>
    );
  } 
  else if (homePanels.length === 3) {
    return (
        <div className="panelHolder" id="homePanelHolder">
            <div className="row">
            {homePanels.map(hPanel => {
                const ctaURL = "../" + hPanel.fields.link;
                const svgString = hPanel.fields.svgCode;
      return (
            <div className="col-sm-6 col-lg-4" key={hPanel.fields.title}>
                <div className="panelSvg">
                    <Link to={ctaURL} reloadDocument className="ctaLink" >
                    <div className="panelIcon" 
                        dangerouslySetInnerHTML={{
                        __html: svgString,
                    }}
                    />
                    </Link>
                </div>
                <h2 className="panelTitle">{hPanel.fields.title}</h2>
                <p className="panelText">{hPanel.fields.description}</p>
                <Link to={ctaURL} reloadDocument className="ctaLink" key={hPanel.fields.link}>FIND OUT MORE...</Link>
            </div>
      );
    })}
            </div>
        </div>
    );
  } 
  else if (homePanels.length === 4) {
    return (
        <div className="panelHolder" id="homePanelHolder">
            <div className="row">
            {homePanels.map(hPanel => {
                const ctaURL = "../" + hPanel.fields.link;
                const svgString = hPanel.fields.svgCode;
      return (
            <div className="col-sm-6 col-lg-3" key={hPanel.fields.title}>
                <div className="panelSvg">
                    <Link to={ctaURL} reloadDocument className="ctaLink" >
                    <div className="panelIcon" 
                        dangerouslySetInnerHTML={{
                        __html: svgString,
                    }}
                    />
                    </Link>
                </div>
                <h2 className="panelTitle">{hPanel.fields.title}</h2>
                <p className="panelText">{hPanel.fields.description}</p>
                <Link to={ctaURL} reloadDocument className="ctaLink" key={hPanel.fields.link}>FIND OUT MORE...</Link>
            </div>
      );
    })}
            </div>
        </div>
    );
  } 

}

export default HomePanels;
